import Colors from "../../../global/Colors";

export const FilterListConfig = [
  {
    fieldName: "search",
    title: "Search",
    filterType: "Search",
    currentValue: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
      clearValueOnDelete: true,
    },
  },
  {
    fieldName: "assigned_users",
    title: "Assigned Users",
    filterType: "MultiSelectSearch",
    searchTitle: "User Search",
    currentValue: [],
    nameKey: "value",
    valueKey: "key",
    apiUrl: `core/dynamic-options/assignable-users/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "role_id",
    title: "Assigned Roles",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Assigned Roles",
    currentValue: [],
    nameKey: "value",
    valueKey: "key",
    apiUrl: `core/dynamic-options/user-roles/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "role_id_not__in",
    title: "Unassigned Roles",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Unassigned Roles",
    currentValue: [],
    nameKey: "value",
    valueKey: "key",
    apiUrl: `core/dynamic-options/user-roles/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "law_firm",
    title: "Law Firms",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Law Firms",
    currentValue: [],
    orderingVal: "order",
    nameKey: "value",
    valueKey: "key",
    apiUrl: `core/dynamic-options/law-firms/`,
    permission: "lawyer.view_lawfirm",
    activeChip: {
      isActive: false,
      color: Colors.yellow[500],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "status",
    title: "Medical Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Medical Status",
    dashboardWidgetSelections: [],
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=case&field_name=status&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "legal_status",
    title: "Legal Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Medical Status",
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=case&field_name=legal_status&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.green[400],
      label: "",
    },
  },
  {
    fieldName: "overall_status",
    title: "Case Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Case Status",
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=case&field_name=overall_status&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
  },
  {
    fieldName: "flag",
    title: "Case Flagged (AND)",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Flags",
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/flags/?`,
    permission: "core.view_auditflag",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "created_at",
    title: "Date Created",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "last_note",
    title: "Last Note Added",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "last_appointment",
    title: "Last Appointment Added",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "actual_total_settlement_amount",
    title: "Settlement Amount",
    filterType: "RangeSlider",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "medical_limit",
    title: "Medical Limits Available",
    filterType: "RangeSlider",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "property_damage_amount",
    title: "Property Damage Amount",
    filterType: "RangeSlider",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "running_total",
    title: "Received Bill Charges",
    filterType: "RangeSlider",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "has_had_email_sent",
    title: "Has Had Email Sent",
    filterType: "SearchOptionGroup",
    searchTitle: "Has Had Email Sent",
    currentValue: null,
    apiUrl: `case/email/?has_had_email_sent=true&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
  },
  {
    fieldName: "email_template_sent",
    title: "Has Had Specific Email Template Sent",
    filterType: "MultiSelectSearch",
    searchTitle: "Has Had Specific Email Template Sent",
    dashboardWidgetSelections: [],
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/email_templates/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "related_cases",
    title: "Related Cases",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Related Cases",
    currentValue: [],
    nameKey: "name",
    valueKey: "id",
    apiUrl: `case/?`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
    noShowMore: true,
  },

  {
    fieldName: "doc_type",
    title: "Uploaded Document Type",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Uploaded Document Types",
    currentValue: [],
    nameKey: "label",
    valueKey: "key",
    orderingVal: "label",
    apiUrl: `field_options/?content_type=document&field_name=document_type&ordering=order&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "doc_type_not__in",
    title: "Not Uploaded Document Type",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Not Uploaded Document Type",
    currentValue: [],
    orderingVal: "label",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=document&field_name=document_type&ordering=order&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "entity",
    title: "Entities",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Entities",
    currentValue: [],
    nameKey: "name",
    valueKey: "id",
    orderingVal: "label",
    apiUrl: `entities/?is_related_to_law_firm=true&`,
    permission: "users.view_entity",
    activeChip: {
      isActive: false,
      color: Colors.sky[500],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "incident_location",
    title: "Incident State",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Incident State",
    currentValue: [],
    nameKey: "label",
    valueKey: "key",
    orderingVal: "label",
    apiUrl: `field_options/?content_type=case&field_name=incident_location&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.yellow[500],
      label: "",
    },
  },
  {
    fieldName: "incident_location__not_in",
    title: "Incident not in State",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Incident not in State",
    currentValue: [],
    nameKey: "label",
    valueKey: "key",
    orderingVal: "label",
    apiUrl: `field_options/?content_type=case&field_name=incident_location&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
  },

  {
    fieldName: "campaign",
    title: "Campaign",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Campaign",
    currentValue: [],
    nameKey: "value",
    valueKey: "key",
    apiUrl: `core/dynamic-options/campaigns/?`,
    permission: "leads.view_all_campaigns",
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "liability_request_status",
    title: "Liability Request",
    filterType: "SingleSelect",
    currentValue: null,
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=clientcoverage&field_name=liability_request_status&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.amber[500],
      label: "",
    },
  },
  {
    fieldName: "property_damage_severity",
    title: "PD Severity",
    filterType: "SingleSelect",
    currentValue: null,
    nameKey: "label",
    valueKey: "key",
    orderingVal: "order",
    apiUrl: `field_options/?content_type=case&field_name=property_damage_severity&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "lost",
    title: "Lost",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Lost Cases",
    currentValue: [],
    nameKey: "value",
    valueKey: "key",
    apiUrl: `core/dynamic-options/lost-case-options/?`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
    noShowMore: true,
  },
  {
    fieldName: "incident_type",
    title: "Case Type Filter",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Case Filter",
    currentValue: [],
    nameKey: "label",
    valueKey: "key",
    apiUrl: "field_options/?content_type=case&field_name=incident_type&flat=true",
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
  },
  {
    fieldName: "client__date_of_birth",
    title: "Date of Birth",
    filterType: "DatePicker",
    currentValue: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "date_of_accident",
    title: "Date of Accident",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
  },
  {
    fieldName: "updated_at",
    title: "Date Updated",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.amber[500],
      label: "",
    },
  },
  {
    fieldName: "archived",
    title: "Archived",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
  },
  {
    fieldName: "property_damage_severity__isnull",
    title: "Needs PD Severity",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "campaign__isnull",
    title: "Source",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: "HnS",
    customTrueLabel: "Non HnS",
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.purple[500],
      label: "",
    },
  },
  {
    fieldName: "has_law_firm_cm",
    title: "Has Law Firm CM",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
  },
  {
    fieldName: "police_report_received",
    title: "Police Report",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.sky[500],
      label: "",
    },
  },
];
